import styled from 'styled-components';

export const StyledAdminAddGroupPoolConfigForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 12px;

  input {
    width: 46rem;
    height: 100%;

    padding: 1.6rem;
    padding-right: 3.2rem;

    border-radius: 5px;
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    cursor: pointer;

    border: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
    background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text2)};
    transition: all 0.2s ease;

    &::placeholder {
      font-size: 1.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        font-size: 1.4rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      font-size: 1.4rem;
      padding: 1.1rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      width: 30rem;
      padding: 1rem;
    }
  }

  .selected-group {
    border: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
    background-color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg3 : props.theme.bg2)};

    height: 100%;
    border-radius: 5px;
    padding: 1.6rem;
    padding-right: 3.2rem;
    cursor: pointer;
    position: relative;
    z-index: 1;

    font-size: 1.6rem;
    font-weight: 500;
    line-height: 150%;

    &-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      font-size: 1.4rem;
      padding: 1.1rem;
    }

    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
      width: 30rem;
      padding: 1rem;
    }
  }

  .drop-down-arrow {
    position: absolute;
    right: 1.5rem;
    top: 0;
    width: 1.7rem;
    height: 100%;
    transition: all 0.2s;

    > * {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
    transform: scaleX(1) scaleY(1);

    &.collapsed {
      transform: scaleY(-1) scaleX(-1);
    }

    @media (min-width: 768px) and (max-width: 1440px) {
      width: 1.4rem;
    }

    @media screen and (max-width: 768px) {
      width: 1.2rem;
    }
  }

  .custom-dropdown {
    position: absolute;
    width: 46rem;
    background-color: ${({ theme }) => (theme.id === 'dark' ? theme.bg3 : theme.bg2)};
    border: 1px solid
      ${(props) => (props.theme.id === 'dark' ? props.theme.accent2 : props.theme.accent3)};
    border-radius: 5px;
    margin-top: 0.4rem;
    z-index: 10;

        max-height: 40rem;
        overflow-y: auto;
        
    .dropdown-option {
      padding: 0.8rem 1.5rem;
      cursor: pointer;
      font-size: 1.6rem;
      font-weight: 500;

      @media (min-width: 768px) and (max-width: 1440px) {
        font-size: 1.4rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }

      &:hover {
        background-color: ${({ theme }) => (theme.id === 'dark' ? theme.bg2 : theme.bg3)};
      }
    }

    @media screen and (max-width: 768px) {
      width: 30rem;
    }
  }
`;
